import { render, staticRenderFns } from "./XsHeader.vue?vue&type=template&id=0e304deb&scoped=true&"
import script from "./XsHeader.vue?vue&type=script&lang=ts&"
export * from "./XsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./XsHeader.vue?vue&type=style&index=0&id=0e304deb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e304deb",
  null
  
)

export default component.exports